const base = {
    get() {
        const API_BASE = (process.env.VUE_APP_API_BASE || '/springboot6hv37').replace(/\/$/, '') + '/'
        // 图片基址：优先使用 VUE_APP_IMG_BASE；否则从 API_BASE 去掉 springboot 上下文，直指网关根
        const API_ORIGIN = API_BASE.replace(/\/springboot6hv37\/?$/, '/')
        // const IMG_BASE = (process.env.VUE_APP_IMG_BASE || API_ORIGIN).replace(/\/$/, '') + '/'
        const IMG_BASE = 'https://api-do.whitelotus.work/'

        const INDEX_BASE = (process.env.VUE_APP_INDEX_BASE || API_BASE).replace(/\/$/, '')
        return {
            // 开发模式下使用相对路径，让vue proxy代理到后端
            url: API_BASE,
            imgurl: IMG_BASE,
            name: "springboot6hv37",
            // 退出到首页链接
            indexUrl: `${INDEX_BASE}front/index.html`
        };
    },
    getProjectName(){
        return {
            projectName: "White Lotus Booking System"
        } 
    }
}
export default base
